<template>
  <section ref="qrPanel" class="qr-panel display-panel">
    <div v-if="hasQrPayload" class="qr-card" :style="qrCardStyle">
      <div class="qr-header">
        <img :src="khqrHeader" alt="KHQR" />
      </div>
      <div ref="qrBody" class="qr-body">
        <div ref="qrContent" class="qr-content" :style="qrContentStyle">
          <div class="qr-payee">{{ displayName }}</div>
          <div class="qr-amount">{{ displayAmount }}</div>
        </div>
        <div class="qr-canvas-wrap qr-generated-wrap">
          <ts-qr-code
            :value="displayPayload"
            :size="qrCodeSize"
            :icon="bakongSymbol"
            :icon-size="qrIconSize"
            @error="onQrRenderError"
          />
        </div>
      </div>
    </div>
    <div v-else class="qr-empty">
      <i class="far fa-money-bill-alt"></i>
      <strong>{{ $t('customerDisplay.qrPaymentTitle') }}</strong>
      <span>{{ $t('customerDisplay.waitingDataEn') }}</span>
    </div>
  </section>
</template>

<script>
import khqrHeader from '@/assets/khqr/kqr-header.png'
import bakongSymbol from '@/assets/khqr/bakong_symbol.png'
import TsQrCode from '@/components/common/TsQrCode.vue'

export default {
  name: 'QrPaymentPanel',
  components: { TsQrCode },
  props: {
    khqr: { type: Object, default: null },
    name: { type: String, default: '-' },
    summaryDue: { type: Number, default: 0 }
  },
  data() {
    return {
      bakongSymbol,
      khqrHeader,
      qrPanelHeight: 320,
      qrPanelWidth: 320,
      qrBodyHeight: 240,
      qrContentHeight: 58,
      qrRenderError: null
    }
  },
  computed: {
    displayAmount() {
      const amount = Number((this.khqr && this.khqr.amount) || this.summaryDue || 0)
      const currency = String((this.khqr && this.khqr.currency_code) || 'USD').toUpperCase()
      const fraction = currency === 'KHR' ? 0 : 2
      return `${amount.toLocaleString(undefined, { minimumFractionDigits: fraction, maximumFractionDigits: fraction })} ${currency}`
    },
    displayName() {
      return this.name || '-'
    },
    displayPayload() {
      return this.khqr && this.khqr.qr_payload ? this.khqr.qr_payload : ''
    },
    hasQrPayload() {
      return Boolean(this.displayPayload)
    },
    qrCardHeight() {
      const panelLimit = Math.max(160, this.qrPanelHeight - 2)
      const widthLimit = Math.max(160, this.qrPanelWidth * 1.08)
      return Math.floor(Math.min(panelLimit, widthLimit, 360))
    },
    qrCardWidth() {
      return Math.floor(this.qrCardHeight / 1.12)
    },
    qrCardStyle() {
      return {
        width: this.qrCardWidth + 'px',
        height: this.qrCardHeight + 'px'
      }
    },
    qrCodeSize() {
      const verticalChrome = this.qrContentHeight + 16
      const availableHeight = Math.max(72, this.qrBodyHeight - verticalChrome)
      const heightBased = Math.floor(availableHeight * 0.96)
      const widthBased = Math.floor(this.qrCardWidth * 0.84)
      return Math.max(72, Math.min(280, heightBased, widthBased))
    },
    qrIconSize() {
      return Math.max(24, Math.floor(this.qrCodeSize * 0.16))
    },
    qrContentStyle() {
      return {
        width: this.qrCodeSize + 'px'
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.updateQrPanelSize)
    this.$nextTick(this.updateQrPanelSize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateQrPanelSize)
  },
  methods: {
    onQrRenderError(error) {
      this.qrRenderError = error ? error.message || String(error) : null
    },
    updateQrPanelSize() {
      const panel = this.$refs.qrPanel
      const body = this.$refs.qrBody
      const content = this.$refs.qrContent
      if (!panel || !panel.getBoundingClientRect) return
      const rect = panel.getBoundingClientRect()
      this.qrPanelWidth = Math.max(1, Math.floor(rect.width))
      this.qrPanelHeight = Math.max(1, Math.floor(rect.height))
      if (body && body.getBoundingClientRect) {
        this.qrBodyHeight = Math.max(1, Math.floor(body.getBoundingClientRect().height))
      }
      if (content && content.getBoundingClientRect) {
        this.qrContentHeight = Math.max(1, Math.ceil(content.getBoundingClientRect().height))
      }
    }
  }
}
</script>
